import { render, staticRenderFns } from "./MarkUpPinsDetail.vue?vue&type=template&id=6f5c1f46&"
import script from "./MarkUpPinsDetail.vue?vue&type=script&lang=js&"
export * from "./MarkUpPinsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports